
import { defineComponent, ref, watch } from "vue";
import { useRoute } from "vue-router";
// import { HomeFilled } from "@element-plus/icons-vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "asideList",
  props: {
    collapseState: Boolean,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const tabRoutes = () => {
      const arr = [] as any;
      store.state.routerArr.map((item: any) => {
        if (item.children) {
          arr.push(item);
        }
      });
      return arr;
    };
    const menuItem = ref();
    const isCollapse = ref(true);
    // const handleOpen = (key: string, keyPath: string[]) => {
    //   // console.log(key, keyPath);
    //   // console.log(menuItem.value);
    // };
    // const myMenu = (e: any) => {
    //   if (props.collapseState == true) {
    //     menuItem.value.forEach((item: any) => {
    //       // console.log(item);
    //       if (item.index == e.index) {
    //         console.log(item.index);
    //         console.log(e.index);
    //         // item.rootMenu.props.textColor = "#333"
    //       }
    //     });
    //   }
    // };
    return { isCollapse, tabRoutes, route, menuItem, watch };
  },
});
